import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackFormSubmitParameters extends TrackEventBaseParameters<null, "form_name"> {}

const trackFormSubmit = (parameters: TrackFormSubmitParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "submit_form", ...parameters }, options);
};

export default trackFormSubmit;
